export var RunMethod;
(function (RunMethod) {
    RunMethod[RunMethod["AutoRun"] = 0] = "AutoRun";
    RunMethod[RunMethod["AutoStart"] = 1] = "AutoStart";
    RunMethod[RunMethod["Step"] = 2] = "Step";
    RunMethod[RunMethod["UntilExpand"] = 3] = "UntilExpand";
})(RunMethod || (RunMethod = {}));
